import { render, staticRenderFns } from "./assetAnnotationWithComments.vue?vue&type=template&id=1d23bc4a&scoped=true"
import script from "./assetAnnotationWithComments.vue?vue&type=script&lang=js"
export * from "./assetAnnotationWithComments.vue?vue&type=script&lang=js"
import style0 from "./assetAnnotationWithComments.vue?vue&type=style&index=0&id=1d23bc4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d23bc4a",
  null
  
)

export default component.exports